<template>
    <div>
        <CCol sm="12">
            <CCol sm="12">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" @click="GoToSettingProfile()"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
               
                <CCard class="custom-border-radius-16px" style="border:none;">
                    <img :src="require('@/assets/img/bg-personal-detail.png')" alt="View" style="cursor: pointer;width:100%" />
                </CCard>
                <CRow class="p-2">
                        <CCol sm="12">
                            <CCard class="custom-border-radius-12px" style="margin-top: -130px;">
                                <div class="p-2">
                        <CRow>
                            <CCol sm="2">
                                <!-- <img :src="LogoPath" style="max-width:150px" /> -->
                                <img src="../assets/img/profile.png" style="max-width:104px" />
                                <img src="../assets/img/camera.png" style="max-width:36px; margin-left:-26px; margin-top:58px;" class="mr-5" />
                            </CCol>
                            <CCol sm="10" style="padding-top: 10px;">
                                <CRow>
                                    <CCol sm="10">
                                        <h1 class="font-color-171717" style="font-size: 24px;font-weight: 600;">{{ detailStaff.FullName }}</h1>
                                        <h1 class="font-color-171717" style="font-size: 16px;font-weight: 400; color: #98A2B3;">{{ detailStaff.PositionName }}</h1>
                                    </CCol>
                                    <CCol sm="2">
                                        <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right" @click="openAddPersonal()"/>
                                    </CCol>
                                    <CCol sm="3">
                                        <CRow>
                                            <img src="../assets/img/emailRound.png" style="max-width:36px;"/>
                                            <h3 class="custom-14px-500 font-color-171717 mt-2">{{ detailStaff.Email }}</h3>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="3">
                                        <CRow>
                                            <img src="../assets/img/call.png" style="max-width:36px; max-height: 17px;margin-top: 10px;margin-right: 6px;"/>
                                            <h3 class="custom-14px-500 font-color-171717 mt-2">{{ detailStaff.PhoneNumber }}</h3>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="3">
                                        <CRow>
                                            <img src="../assets/img/briefcase1.png" style="max-width:36px; max-height: 19px;margin-top: 10px;margin-right: 6px;"/>
                                            <h3 class="custom-14px-500 font-color-171717 mt-2">{{ detailStaff.DepartmentName }}</h3>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="6">
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </div>
                            </CCard>
                        </CCol>
                     </CRow>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Personal Detail</h3>
                            </CCol>
                            <CCol sm="2">
                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right" @click="editPersonal()"/>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Full Name</h3>
                                        <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">NRIC</h3>
                                        <CInput type="text" v-model="detailStaff.Nric" :disabled="!isEditable"/>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">NRIC (Old)</h3>
                                        <CInput type="text" v-model="detailStaff.NricOld" :disabled="!isEditable"/>
                                        
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">NRIC Color</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.CompanyTypeName" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedNricColor" :options="nricColorOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Date of Birth</h3>
                                        <!-- <CInput type="date" v-model="detailStaff.DateOfBirth" :disabled="!isEditable"/> -->
                                        <CInput 
                                        class="uniform-input"
                                            type="date" 
                                            v-model="formattedDateOfBirth" 
                                            :disabled="!isEditable" 
                                            @input="updateDateOfBirth"
                                        />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Place Of Birth</h3>
                                        <CInput type="text" v-model="detailStaff.PlaceOfBirth" :disabled="!isEditable"/>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Gender</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.CompanyTypeName" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedGender" :options="genderOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Race</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.FullNames" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedRace" :options="raceOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Religion</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.FullNames" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedReligion" :options="religionOptions" label="Name" :disabled="!isEditable"></v-select>
                                        
                                    </CCol>
                                    <CCol sm="4" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Blood Type</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.ShortName" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedBloodType" :options="bloodTypeOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="4" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Educational Level</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.RegistrationNumber" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedEduLevel" :options="eduLevelOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="4" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Marital Status</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.CompanyTypeName" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedMarital" :options="maritalOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="4" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Family Member</h3>
                                        <CInput type="text" v-model="detailStaff.FamilyMember" :disabled="!isEditable"/>
                                    </CCol>
                                    <CCol sm="4" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Nationality</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.RegistrationNumber" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedNationality" :options="nationalityOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                    <CCol sm="4" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Bumi Status</h3>
                                        <!-- <CInput type="text" v-model="detailStaff.CompanyTypeName" :disabled="!isEditable"/> -->
                                        <v-select v-model="selectedBumi" :options="bumiOptions" label="Name" :disabled="!isEditable"></v-select>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow v-if="isEditable" class="mt-3">
                            <CCol sm="12" class="text-right">
                                <CButton color="primary" @click="SubmitPersonalDetails()">Save Changes</CButton>
                            </CCol>
                        </CRow>
    
                    </div>
                </div>
    
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
    <div>
      <div class="p-2">
        <CRow>
          <CCol sm="10">
            <h3 class="custom-18px-500 font-color-171717">Driving License Details</h3>
          </CCol>
          <CCol sm="2">
            <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right" @click="editLicense()" />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="4">
                <h3 class="custom-14px-500 font-color-171717">Driving License Number</h3>
                <CInput type="text" v-model="detailStaff.DrivingLicenseNumber" :disabled="!isEditLicense" />
              </CCol>
              <CCol sm="4">
                <h3 class="custom-14px-500 font-color-171717">Driving Class</h3>
                <v-select v-model="selectedDrivingClass" :options="drivingOptions" label="Name" :disabled="!isEditLicense"></v-select>
              </CCol>
              <CCol sm="4">
                <h3 class="custom-14px-500 font-color-171717">Driving Expiry Date</h3>
                <!-- <CInput type="date" v-model="detailStaff.DrivingExpiryDate" :disabled="!isEditLicense" /> -->
                <CInput 
                    type="date" 
                    v-model="formattedDrivingExpiryDate" 
                    :disabled="!isEditLicense" 
                    @input="updateDrivingExpiryDate"
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow v-if="isEditLicense" class="mt-3">
          <CCol sm="12" class="text-right">
            <CButton color="primary" @click="SubmitDrivingDetails()">Save Changes</CButton>
          </CCol>
        </CRow>
      </div>
    </div>
  </CCard>
                <!-- <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Work Experince</h3>
                            </CCol>
                            <CCol sm="2">
                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right" @click="openAddExperience()"/>
                            </CCol>
                        </CRow>
                    </div>
                    <CRow>
                    <CCol sm="6">
                        <CCard class="p-3 custom-border-radius-16px" style="border-color:revert-layer;">
                            <h3 class="custom-14px-600 font-inter font-color-171717">UI/UX Designer</h3>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Cinta Hati Sdn Bhd - Full Time</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Jun 2020 - Present (1y 1m)</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Malaysia</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Created and executed social media plan for 10 brands utilizing multiple features and content types to increase brand outreach, engagement, and leads.</h5>
    
                        </CCard>
                    </CCol>
                    <CCol sm="6">
                        <CCard class="p-3 custom-border-radius-16px" style="border-color:revert-layer;">
                            <h3 class="custom-14px-600 font-inter font-color-171717">Web Developer</h3>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Cinta Hati Sdn Bhd - Full Time</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Jun 2020 - Present (1y 1m)</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Malaysia</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">Created and executed social media plan for 10 brands utilizing multiple features and content types to increase brand outreach, engagement, and leads.</h5>
    
                        </CCard>
                    </CCol>
                </CRow>
                </div>
    
                </CCard> -->

                <CCard class="p-2 custom-border-radius-16px" style="border: none;">
                    <div>
                    <div class="p-2">
                        <CRow>
                        <CCol sm="10">
                            <h3 class="custom-18px-500 font-color-171717">Work Experience</h3>
                        </CCol>
                        <CCol sm="2">
                            <img
                            src="../assets/img/edit-linear.png"
                            style="max-width: 18px;"
                            class="float-right"
                            @click="openAddExperience"
                            />
                        </CCol>
                        </CRow>
                    </div>
                    <CRow>
                        <CCol v-for="(experience, index) in workEx" :key="index" sm="6">
                        <CCard class="p-3 custom-border-radius-16px" style="border-color: revert-layer;">
                            <h3 class="custom-14px-600 font-inter font-color-171717">{{ experience.Position }}</h3>
                            <h5 class="custom-14px-600 font-inter font-color-171717">
                            {{ experience.PreviousCompany }}
                            </h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">
                            {{ formatDate(experience.StartDate) }} - 
                            {{ experience.endDate ? formatDate(experience.EndDate) : "Present" }}
                            </h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">{{ experience.location }}</h5>
                            <h5 class="custom-14px-600 font-inter font-color-171717">
                            {{ experience.description }}
                            </h5>
                        </CCard>
                        </CCol>
                    </CRow>
                    </div>
                </CCard>
            </CCol>
    
        </CCol>
        <div v-if="OpenAddPersonal" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Update Profile</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddPersonal" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">FullName</h3>
                                        <CInput type="text" v-model="detailStaff.FullName" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Mobile Phone</h3>
                                        <CInput type="text" v-model="detailStaff.PhoneNumber" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Address</h3>
                                        <CInput type="text" v-model="detailStaff.Address" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Email</h3>
                                        <CInput type="text" v-model="detailStaff.Email" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Staff Number</h3>
                                        <CInput type="text" v-model="detailStaff.StaffNo" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Status Employment</h3>
                                        <v-select type="text" v-model="detailStaff.StatusEmployment" :options="employmentOptions" label="Name" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Department</h3>
                                        <v-select type="text" class="" v-model="detailStaff.DepartmentName" :options="departmentOptions" label="Name" />
                                    </CCol>
                                    <CCol sm="6" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">Position</h3>
                                        <v-select type="text" class="" v-model="detailStaff.PositionName" :options="positionOptions" label="Name" />
                                    </CCol>
                                    <CCol sm="6" class="mt-3">
                                        <h3 class="custom-14px-500 font-color-171717">User Type</h3>
                                        <v-select type="text" v-model="detailStaff.UserType" :options="userOptions" label="Name" />
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="mt-3 p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="U[dateUserData]">
                                Update</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="OpenAddExperience" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Add Experience</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddExperience" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Previous Company</h3>
                                        <CInput type="text" v-model="detailStaff.PreviousCompany" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Position</h3>
                                        <CInput type="text" v-model="detailStaff.Position" />
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Start Date</h3>
                                        <CInput type="date" v-model="detailStaff.StartDate" />
                                    </CCol>
                                    <CCol sm="6">
                                        <!-- <h3 class="custom-14px-500 font-color-171717">End Date</h3>
                                        <CInput type="date" v-model="FullName" />
                                        <h3 class="custom-14px-500 font-color-171717">I am currently working in this role!<input type="checkbox" class="ml-2 mb-2" /></h3> -->

                                        <h3 class="custom-14px-500 font-color-171717">End Date</h3>
                                        <CInput 
                                            type="date" 
                                            v-model="detailStaff.EndDate" 
                                            :disabled="isCurrentRole" 
                                        />
                                        <h3 class="custom-14px-500 font-color-171717">
                                            I am currently working in this role!
                                            <input 
                                            type="checkbox" 
                                            class="ml-2 mb-2" 
                                            v-model="isCurrentRole" 
                                            />
                                        </h3>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitWorkExperince">
                                Update</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},
            isPopupSuccess: false,
            OpenAddPersonal: false,
            OpenAddExperience: false,

            isEditable: false, // State to toggle editable fields
            isEditLicense: false,
            detailStaff: {
                ShortName: '',
                RegistrationNumber: '',
                CompanyTypeName: ''
            },
            selectedNricColor: "",
            nricColorOptions: [],
            selectedGender: "",
            genderOptions: [],

            selectedRace: "",
            raceOptions: [],
            selectedReligion: "",
            religionOptions: [],
            selectedBloodType: "",
            bloodTypeOptions: [],
            selectedEduLevel: "",
            eduLevelOptions: [],
            selectedMarital: "",
            maritalOptions: [],
            selectedNationality: "",
            nationalityOptions: [],
            selectedBumi: "",
            bumiOptions: [],
            selectedDrivingClass: "",
            drivingOptions: [],

            selectedStatusEmployment: "",
            employmentOptions: [],
            selectedDepartment: "",
            departmentOptions: [],
            selectedUserType: "",
            userOptions: [],
            selectedPosition: "",
            positionOptions: [],

            endDate: '', // Model for the End Date field
            isCurrentRole: false, // Checkbox state
            workEx: [],

        }
    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();
        await this.GetNricColor();

        await this.GetRace();
        await this.GetGender();
        await this.GetReligion();
        await this.GetBloodType();
        await this.GetEduLevel();
        await this.GetMarital();
        await this.GetNationality();
        await this.GetBumi();
        await this.GetDrivingClass();
        await this.GetListWorkExperience();

        await this.GetEmployment();
        await this.GetDepartment();
        await this.GetUserType();
        await this.GetPosition();

        await this.SetupSelectedOption();

        

    },

    computed: {
        formattedDrivingExpiryDate: {
            get() {
                return this.detailStaff.DrivingExpiryDate 
                    ? this.detailStaff.DrivingExpiryDate.split('T')[0] // Ensures correct format for input[type="date"]
                    : '';
            },
            set(value) {
                this.detailStaff.DrivingExpiryDate = value;
            }
        },
        formattedDateOfBirth: {
            get() {
                return this.detailStaff.DateOfBirth
                    ? this.detailStaff.DateOfBirth.split('T')[0] // Ensures correct format for input[type="date"]
                    : '';
            },
            set(value) {
                this.detailStaff.DateOfBirth = value;
            }
        },

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                this.detailStaff = response.data;
                if (response.status === 200 && this.detailStaff != null) {

                    //this.detailStaff = response.data;

                    this.NricColor = this.detailStaff.NricColor;
                    this.Gender = this.detailStaff.Gender;
                    this.Race = this.detailStaff.Race;

                    this.Religion = this.detailStaff.Religion;
                    this.BloodType = this.detailStaff.BloodType;
                    this.EduLevel = this.detailStaff.EduLevel;

                    this.MaritalStatus = this.detailStaff.MaritalStatus;
                    this.Nationality = this.detailStaff.Nationality;
                    this.BumiStatus = this.detailStaff.BumiStatus;

                    this.DrivingClass = this.detailStaff.DrivingClass;

                    this.StatusEmployment = this.detailStaff.StatusEmployment;
                    this.DepartmentName = this.detailStaff.DepartmentName;
                    this.PositionName = this.detailStaff.PositionName;
                    this.UserType = this.detailStaff.UserType;

                    this.SetupSelectedOption(this.NricColor);

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        openAddPersonal() {
            this.OpenAddPersonal = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenAddPersonal = false;
        },
        closePopupAddPersonal() {
            this.OpenAddPersonal = false;
        },

        openAddExperience() {
            this.OpenAddExperience = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenAddExperience = false;
        },
        closePopupAddExperience() {
            this.OpenAddExperience = false;
        },
        editLicense() {
        this.isEditLicense = !this.isEditLicense; // Toggle edit mode
        },
        editPersonal() {
        this.isEditable = !this.isEditable; // Toggle edit mode
        },
        saveChanges() {
        // Add logic to save the changes
        this.isEditLicense = false; // Disable fields after saving
        console.log('Changes saved:', this.detailStaff);
        },
        async GetNricColor() {
                try {
                    const response = await this.$API.get(this.$GetListNricColor, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.nricColorOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetGender() {
                try {
                    const response = await this.$API.get(this.$GetListGender, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.genderOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetRace() {
                try {
                    const response = await this.$API.get(this.$GetListRace, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.raceOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetReligion() {
                try {
                    const response = await this.$API.get(this.$GetListReligion, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.religionOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetBloodType() {
                try {
                    const response = await this.$API.get(this.$GetListBloodTyoe, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.bloodTypeOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetEduLevel() {
                try {
                    const response = await this.$API.get(this.$GetListEduLevel, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.eduLevelOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetMarital() {
                try {
                    const response = await this.$API.get(this.$GetListMaritalStatus, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.maritalOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetBumi() {
                try {
                    const response = await this.$API.get(this.$GetListBumiStatus, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.bumiOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetNationality() {
                try {
                    const response = await this.$API.get(this.$GetListNationality, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.nationalityOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetDrivingClass() {
                try {
                    const response = await this.$API.get(this.$GetListDrivingClass, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.drivingOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        SubmitPersonalDetails() {
            const formData = new FormData();
            
            formData.append("StaffUserId", this.$route.query.id);
            formData.append("Nric", this.detailStaff.Nric);
            formData.append("NricOld", this.detailStaff.NricOld);
            formData.append("NricColorId", this.selectedNricColor.Id);
            formData.append("DateOfBirth", this.detailStaff.DateOfBirth);
            formData.append("PlaceOfBirth", this.detailStaff.PlaceOfBirth);
            formData.append("GenderId", this.selectedGender.Id);
            formData.append("RaceId", this.selectedRace.Id);
            formData.append("ReligionId", this.selectedReligion.Id);
            formData.append("BloodTypeId", this.selectedBloodType.Id);
            formData.append("EducationalLevelId", this.selectedEduLevel.Id);
            formData.append("MaritalStatusId", this.selectedMarital.Id);

            formData.append("FamilyMember", this.detailStaff.FamilyMember);
            formData.append("NationalityId", this.selectedNationality.Id);
            formData.append("BumiStatusId", this.selectedBumi.Id);


            this.$API
                .post(this.$UpdatePersonalDetails, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.isPopupSuccess = true;


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SubmitDrivingDetails() {
            const formData = new FormData();
            
            formData.append("UserStaffId", this.$route.query.id);
            formData.append("DrivingLicenseNumber", this.detailStaff.DrivingLicenseNumber);
            formData.append("DrivingClassId", this.selectedDrivingClass.Id);
            formData.append("DrivingExpiryDate", this.detailStaff.DrivingExpiryDate);
            this.$API
                .post(this.$UpdateStaffDrivingLicense, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.isPopupSuccess = true;


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SubmitWorkExperince() {
            const formData = new FormData();
            
            formData.append("UserStaffId", this.$route.query.id);
            formData.append("PreviousCompany", this.detailStaff.PreviousCompany);
            formData.append("Position", this.detailStaff.Position);
            formData.append("StartDate", this.detailStaff.StartDate);
            // Check if the user is still working and handle EndDate
            if (this.detailStaff.isCurrentRole) {
                formData.append("EndDate", ""); // Add blank if still working
            } else {
                formData.append("EndDate", this.detailStaff.EndDate || ""); // Use EndDate if available or blank
            }
            this.$API
                .post(this.$UpdateWorkExperience, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.isPopupSuccess = true;


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SetupSelectedOption(NricColor) {
            this.selectedNricColor = _.find(this.nricColorOptions, {
                Name: this.NricColor,
            });
            this.selectedGender = _.find(this.genderOptions, {
                Name: this.Gender,
            });
            this.selectedRace = _.find(this.raceOptions, {
                Name: this.Race,
            });
            this.selectedReligion = _.find(this.religionOptions, {
                Name: this.Religion,
            });
            this.selectedBloodType = _.find(this.bloodTypeOptions, {
                Name: this.BloodType,
            });
            this.selectedEduLevel = _.find(this.eduLevelOptions, {
                Name: this.EduLevel,
            });
            this.selectedMarital = _.find(this.maritalOptions, {
                Name: this.MaritalStatus,
            });
            this.selectedNationality = _.find(this.nationalityOptions, {
                Name: this.Nationality,
            });
            this.selectedBumi = _.find(this.bumiOptions, {
                Name: this.BumiStatus,
            });
            this.selectedDrivingClass = _.find(this.drivingOptions, {
                Name: this.DrivingClass,
            });

            this.selectedStatusEmployment = _.find(this.employmentOptions, {
                Name: this.StatusEmployment,
            });
            this.selectedDepartment = _.find(this.departmentOptions, {
                Name: this.DepartmentName,
            });
            this.selectedPosition = _.find(this.positionOptions, {
                Name: this.PositionName,
            });
            this.selectedUserType = _.find(this.userOptions, {
                Name: this.UserType,
            });
        },
        async GetListWorkExperience(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetWorkExperience + "?userStaffId=" + this.$route.query.id, {
                    withCredentials: true,
                });
                //this.detailStaff = response.data;
                if (response.status === 200 && this.detailStaff != null) {

                    this.workEx = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        formatDate(date) {
        const options = { year: "numeric", month: "short" };
        return new Date(date).toLocaleDateString("en-US", options);
        },
        updateDrivingExpiryDate(event) {
            this.detailStaff.DrivingExpiryDate = event.target.value;
        },
        updateDateOfBirth(event) {
            this.detailStaff.DateOfBirth = event.target.value;
        },
        async GoToSettingProfile(pageName = "SettingProfile") {
            let id = this.$route.query.id; 

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                try {
                    await this.GetInfoUser();
                    id = this.user?.id; 

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); 
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            this.$router.push({ name: pageName, query: { id } });
        },
        async GetEmployment() {
                try {
                    const response = await this.$API.get(this.$GetEmployment, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.employmentOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetUserType() {
              try {
                  const response = await this.$API.get(this.$GetUserType);
                  if (response.status === 200) {
                      this.userOptions = response.data;
                  } else {
                      // Handle non-200 status code
                      console.error("Failed to fetch user information:", response);
                  }
              } catch (error) {
                  console.error("Error fetching user information:", error);
                  // Handle the error here
              }
        },
        async GetDepartment() {
                try {
                    const response = await this.$API.get(this.$GetDepartment, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.departmentOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetPosition() {
                try {
                    const response = await this.$API.get(this.$GetPosition, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.positionOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        UpdateUserData() {
            const formData = new FormData();
            
            formData.append("Id", this.$route.query.id);
            formData.append("FullName", this.detailStaff.FullName);
            formData.append("PhoneNumber", this.detailStaff.PhoneNumber);
            formData.append("Address", this.detailStaff.Address);
            formData.append("Email", this.detailStaff.Email);
            formData.append("StaffNo", this.detailStaff.StaffNo);
            formData.append("EmploymentId", this.selectedStatusEmployment.Id);
            formData.append("DepartmentId", this.selectedDepartment.Id);
            formData.append("PositionId", this.selectedPosition.Id);
            formData.append("UserType", this.selectedUserType.Name);


            this.$API
                .post(this.$UpdateUserData, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.isPopupSuccess = true;


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
    }

};
</script>
<style>

</style>